import React from 'react';
import { useTranslation } from 'react-i18next';
import { Carousel } from 'pages/home.page/video-carousel/carousel';

const LIST_TRANSLATIONS = {
  mostPlayed: 'most-played',
  newest: 'newest',
  topRated: 'top-rated',
};

export const SortedVideosDecorated = ({ sortedLists, withRelatedVideos, withRating }) => {
  const { t } = useTranslation();

  return sortedLists.map((list, index) => {
    if (list.type === 'topRated' && !withRating) {
      return false;
    }

    return (
      <div key={'vl-' + index + '-' + list.type}>
        <button
          type="button"
          data-e2e={`sorted-videos-${LIST_TRANSLATIONS[list.type]}`}
          className="ct-home-page__title"
        >
          {t(LIST_TRANSLATIONS[list.type])}
        </button>
        <Carousel
          ariaLabel={t(LIST_TRANSLATIONS[list.type])}
          channelId={list.type}
          baseUrl={''}
          withRelatedVideos={withRelatedVideos} />
      </div>
    );
  });
};
